import { useState } from "react";
import { Check, X } from "lucide-react";

// Driver = editable assumption (dotted underline), distinct from drillable facts
export function DriverCell({ value, onSave, display, testId }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState("");

  const start = (e) => {
    e.stopPropagation();
    setDraft(String(value));
    setEditing(true);
  };
  const save = () => {
    const n = Number(draft);
    if (!Number.isNaN(n)) onSave(n);
    setEditing(false);
  };

  if (editing)
    return (
      <span className="inline-flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
        <input
          autoFocus
          data-testid={`${testId}-input`}
          className="num w-24 px-1.5 py-0.5 text-sm rounded border outline-none"
          style={{ borderColor: "var(--teal)", background: "var(--white)" }}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setEditing(false); }}
        />
        <button data-testid={`${testId}-save`} onClick={save} style={{ color: "var(--good)" }}><Check size={14} /></button>
        <button onClick={() => setEditing(false)} style={{ color: "var(--bad)" }}><X size={14} /></button>
      </span>
    );

  return (
    <span className="driver-cell" data-testid={testId} onClick={start} title="Driver assumption — click to edit">
      {display != null ? display : value}
    </span>
  );
}
